import styled from '@emotion/styled';
import Warning from '@material-ui/icons/Warning';
import Error from '@material-ui/icons/Error';
import Info from '@material-ui/icons/Info';
import CheckCircle from '@material-ui/icons/CheckCircle';
import CircularProgress from '@material-ui/core/CircularProgress';
import theme from '../../themes/default';

const {
  color: { designSystem },
} = theme;

export const AlertIconRoot = styled('div')`
  padding-right: 13px;
`;

export const AlertIcon = styled('div')`
  width: 20px;
  height: 20px;
`;

export const AlertErrorIcon = styled(Error)`
  color: ${designSystem.error};
  width: inherit;
  height: inherit;
`;
export const AlertInfoIcon = styled(Info)`
  color: ${designSystem.information};
  width: inherit;
  height: inherit;
`;
export const AlertSuccessIcon = styled(CheckCircle)`
  color: ${designSystem.success};
  width: inherit;
  height: inherit;
`;
export const AlertWarningIcon = styled(Warning)`
  color: ${designSystem.blackOpacity60};
  width: inherit;
  height: inherit;
`;
export const LoadingWarningIcon = styled(CircularProgress)`
  color: ${designSystem.purple70};
  width: inherit;
  height: inherit;
`;

export default {};
